import { lighten } from 'polished';
import pallette from './pallette';

type ModalsTheme = {
    colors: {
        modals: {
            text: string;
            background: string;
            separators: string;
            overlay: string;
            link: {
                text: string;
                hover: { text: string };
            };
        };
    };
};

const { white, darkBlue, midGreen } = pallette;

const modals: ModalsTheme = {
    colors: {
        modals: {
            text: darkBlue,
            background: white,
            separators: 'rgba(0,0,0,0.2)',
            overlay: 'rgba(0,0,0,0.4)',
            link: {
                text: midGreen,
                hover: {
                    text: lighten(0.1, midGreen),
                },
            },
        },
    },
};

export default modals;
